<template>
  <v-app style="background:white">
    <v-app-bar height="70" class="elevation-0">
      <!-- <v-toolbar height="35" style="background-color:#eee" >
        <v-spacer></v-spacer>
        <h3 class="body-2 mr-2">{{ $t('toolbar.call_us') }} : {{contact_number}}</h3>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small elevation="0" v-on="on">
              {{$i18n.locale}}
              <v-icon ml-2 right small pa-0>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense rounded>
            <v-list-item v-for="(v, i) in langs" :key="i" @click="switch_lang(v.code)">
              <v-list-item-icon>
                <v-icon v-if="$i18n.locale == v.code">mdi-check</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="v.name"></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar> -->
      <v-container>
        <v-toolbar flat>
          <v-toolbar-side-icon>
            <v-img src="@/assets/sky-logo.png" width="100"></v-img>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>

          <div v-if="$vuetify.breakpoint.smAndUp">
            <v-btn text class="ma-1 mr-2" to="/">{{ $t('toolbar.home') }}</v-btn>

            <v-btn text class="ma-1 mr-2" to="login">{{ $t('toolbar.login') }}</v-btn>

            <!-- <v-btn class="ma-1" color="primary" to="register">{{ $t('toolbar.register_now') }}</v-btn> -->
          </div>
        </v-toolbar>
      </v-container>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
// https://jevelin.shufflehound.com/startup-clean/
export default {
  name: "App",
  data: () => ({
    contact_number: "08997541414",
    langs: [
      {
        code: "id",
        name: "Bahasa Indonesia"
      },
      {
        code: "en",
        name: "English"
      }
    ]
  }),
  methods: {
    switch_lang: function(code) {
      this.$i18n.locale = code;
      localStorage.setItem("locale", code);
    }
  }
};
</script>
